import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AccessToken, ChatNotificaties } from '../model/models';
import { API_KEY, BASE_PATH } from '../variables';

@Injectable()
export class KlantService {
    public defaultHeaders = new HttpHeaders();
    protected basePath: string;
    protected apiKey: string;

    constructor(
        protected httpClient: HttpClient,
        @Inject(BASE_PATH) basePath: string,
        @Inject(API_KEY) apiKey: string
    ) {
        this.basePath = basePath;
        this.apiKey = apiKey;
    }

    /**
     * Verwijder de chat notificaties op op basis van de aangeleverde JWT (ingelogde klant)
     */
    public deleteChatNotifications(options?: { httpHeaderAccept?: 'application/problem+json' }): Observable<void> {
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = ['application/problem+json'];
            httpHeaderAcceptSelected = httpHeaderAccepts[0];
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        headers = headers.set('X-Api-Key', this.apiKey);

        let responseType: 'text' | 'json' | 'blob' = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.endsWith('pdf')) {
            responseType = 'blob';
        }

        return this.httpClient.delete<void>(`${this.basePath}/chatnotificaties/ingelogd`, {
            responseType: responseType as any,
            headers
        });
    }

    /**
     * Generate a unique short-lived session-token bound to a user.
     * This is used in the authentication flow with external parties.
     */
    public generateToken(options?: { httpHeaderAccept?: 'application/json' | 'application/problem+json' }): Observable<AccessToken> {
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            const httpHeaderAccepts: string[] = ['application/json', 'application/problem+json'];
            httpHeaderAcceptSelected = httpHeaderAccepts[0];
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        headers = headers.set('X-Api-Key', this.apiKey);

        let responseType: 'text' | 'json' | 'blob' = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.endsWith('pdf')) {
            responseType = 'blob';
        }

        return this.httpClient.post<AccessToken>(`${this.basePath}/tokens`, null, {
            responseType: responseType as any,
            headers
        });
    }

    /**
     * Haalt de chat notificaties op op basis van de aangeleverde JWT (ingelogde klant)
     */
    public getChatNotifications(options?: {
        httpHeaderAccept?: 'application/json' | 'application/problem+json';
    }): Observable<ChatNotificaties> {
        let headers = this.defaultHeaders;
        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = ['application/json', 'application/problem+json'];
            httpHeaderAcceptSelected = httpHeaderAccepts[0];
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        headers = headers.set('X-Api-Key', this.apiKey);

        let responseType: 'text' | 'json' | 'blob' = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.endsWith('pdf')) {
            responseType = 'blob';
        }

        return this.httpClient.get<ChatNotificaties>(`${this.basePath}/chatnotificaties/ingelogd`, {
            responseType: responseType as any,
            headers
        });
    }
}
